export type RazaEventDateScope = "upcoming" | "past";

export type RazaEventListDateQuery = {
  start?: string;
  end?: string;
  sort: { field: "date"; order: "ASC" | "DESC" };
};

/** UTC calendar-day window for raza-event upcoming/past list tabs. */
export function razaEventListDateQuery(
  scope: RazaEventDateScope,
  now: Date = new Date()
): RazaEventListDateQuery {
  const todayUtc = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const todayIso = todayUtc.toISOString().slice(0, 10);

  if (scope === "upcoming") {
    return { start: todayIso, sort: { field: "date", order: "ASC" } };
  }

  const yesterday = new Date(todayUtc);
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  return {
    end: yesterday.toISOString().slice(0, 10),
    sort: { field: "date", order: "DESC" },
  };
}
